import { cn } from "../../lib/utils.ts";

export interface OpennessMeterProps {
  /** How open the mode is, 0–4. More filled dots = more reachable. */
  level: number;
  /** Total dots. */
  max?: number;
  tone?: "gold" | "lime";
  className?: string;
}

/** Spectrum dots that read a tonight-mode as "closed → open" at a glance. */
export function OpennessMeter({ level, max = 4, tone = "gold", className }: OpennessMeterProps) {
  const filled = Math.max(0, Math.min(max, level));
  const fillColor = tone === "lime" ? "var(--lime-500)" : "var(--gold-500)";
  return (
    <span
      className={cn("inline-flex items-center gap-[3px]", className)}
      role="img"
      aria-label={`Openness ${filled} of ${max}`}
      data-testid="openness-meter"
    >
      {Array.from({ length: max }, (_, i) => {
        const isFilled = i < filled;
        return (
          <span
            // biome-ignore lint/suspicious/noArrayIndexKey: fixed-length static meter
            key={i}
            data-filled={isFilled}
            className="block size-[5px] rounded-full"
            style={{ background: isFilled ? fillColor : "var(--cream-4)" }}
          />
        );
      })}
    </span>
  );
}
